import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["value"];
const _hoisted_2 = ["data-max-cols"];
import { computed } from 'vue';
import ThemeFormField from './FormField.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputChoiceSingle',
    props: {
        choices: {},
        name: {},
        modelValue: {},
        maxColumns: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const choicesObjs = computed(() => {
            return props.choices.map((choice) => {
                if (typeof choice === 'string' || typeof choice === 'number') {
                    return {
                        key: choice,
                        label: choice,
                    };
                }
                return choice;
            });
        });
        const emit = __emit;
        const maxCols = computed(() => Math.min(3, Math.max(1, props.maxColumns || 1)));
        const activeChoice = computed(() => {
            return choicesObjs.value.find(c => c.key === props.modelValue);
        });
        function updateValue(key) {
            const choice = choicesObjs.value.find(c => c.key === key);
            emit('update:modelValue', (choice === null || choice === void 0 ? void 0 : choice.hasOwnProperty('value')) ? choice === null || choice === void 0 ? void 0 : choice.value : choice === null || choice === void 0 ? void 0 : choice.key);
        }
        function jsonValue() {
            return JSON.stringify(props.modelValue);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("input", _mergeProps(_ctx.$attrs, {
                    type: "hidden",
                    value: jsonValue()
                }), null, 16, _hoisted_1),
                _createElementVNode("div", {
                    class: "formInputUI",
                    "data-max-cols": maxCols.value
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choicesObjs.value, (choice) => {
                        var _a;
                        return (_openBlock(), _createBlock(ThemeFormField, {
                            type: "radio",
                            key: choice.key,
                            "model-value": ((_a = activeChoice.value) === null || _a === void 0 ? void 0 : _a.key) === choice.key,
                            label: choice.label,
                            name: _ctx.name,
                            "onUpdate:modelValue": ($event) => (updateValue(choice.key))
                        }, null, 8, ["model-value", "label", "name", "onUpdate:modelValue"]));
                    }), 128))
                ], 8, _hoisted_2)
            ], 64));
        };
    }
});
